var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'alert-box__box',
		{ 'alert-box__box-warning': _vm.item.type === 'warning' },
		{ 'alert-box__box-error': _vm.item.type === 'error' }
	]},[_c('svg',{staticClass:"alert-box__success",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 20"}},[_c('path',{class:[
				{ active: _vm.success },
				{ warning: _vm.item.type === 'warning' },
				{ error: _vm.item.type === 'error' }
			],attrs:{"d":"M3 8, L8 13, L18 3"}})]),_c('p',[_vm._v(_vm._s(_vm.item.labels.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }